import {inspectRecursive} from "@/assets/plugins/mps-common/expansions/inspection";

export default (v) => inspectRecursive(v, (object, key, value) => {
    if (value === undefined) delete object[key];
});
